import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TYPES } from '@antv/l7-core';
import BaseLayer from "../../../core/BaseLayer";
import lineFillModel from "../../../line/models/tile";
import lineSimpleModel from "../../../line/models/simpleTileLine";
import pointTextModel from "../../../point/models/tileText";
import pointFillModel from "../../../point/models/tile";
import polygonFillModel from "../../../polygon/models/tile";
import maskModel from "../../../mask/models/fill";

var VectorLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(VectorLayer, _BaseLayer);

  var _super = _createSuper(VectorLayer);

  function VectorLayer() {
    var _this;

    _classCallCheck(this, VectorLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "needListen", true);

    _defineProperty(_assertThisInitialized(_this), "isVector", true);

    _defineProperty(_assertThisInitialized(_this), "isTileLayer", true);

    _defineProperty(_assertThisInitialized(_this), "type", _this.layerType || 'vectorLayer');

    _defineProperty(_assertThisInitialized(_this), "pickedID", null);

    _defineProperty(_assertThisInitialized(_this), "sourceEvent", function () {
      // Tip: vector 不支持 autoFit
      _this.dataState.dataSourceNeedUpdate = true;

      _this.reRender();
    });

    return _this;
  }

  _createClass(VectorLayer, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      // 设置配置项
      var sceneId = this.container.get(TYPES.SceneID);
      this.configService.setLayerConfig(sceneId, this.id, this.rawConfig);
      this.layerType = this.rawConfig.layerType;

      if (this.type === 'PointLayer') {
        // Tip: iconService 和 fontService 只有在矢量点图层中才会被使用
        this.iconService = this.container.get(TYPES.IIconService);
        this.fontService = this.container.get(TYPES.IFontService);
      }

      this.rendererService = this.container.get(TYPES.IRendererService);
      this.layerService = this.container.get(TYPES.ILayerService);
      this.mapService = this.container.get(TYPES.IMapService);
      this.cameraService = this.container.get(TYPES.ICameraService);
      this.coordinateService = this.container.get(TYPES.ICoordinateSystemService);
      this.shaderModuleService = this.container.get(TYPES.IShaderModuleService);
      this.postProcessingPassFactory = this.container.get(TYPES.IFactoryPostProcessingPass);
      this.normalPassFactory = this.container.get(TYPES.IFactoryNormalPass); // 图层容器服务

      this.styleAttributeService = this.container.get(TYPES.IStyleAttributeService); // 完成样式服务注册完成前添加的属性

      this.pendingStyleAttributes.forEach(function (_ref) {
        var attributeName = _ref.attributeName,
            attributeField = _ref.attributeField,
            attributeValues = _ref.attributeValues,
            updateOptions = _ref.updateOptions;

        _this2.styleAttributeService.updateStyleAttribute(attributeName, {
          // @ts-ignore
          scale: _objectSpread({
            field: attributeField
          }, _this2.splitValuesAndCallbackInAttribute( // @ts-ignore
          attributeValues, // @ts-ignore
          _this2.getLayerConfig()[attributeName]))
        }, // @ts-ignore
        updateOptions);
      });
      this.pendingStyleAttributes = []; // 获取插件集

      this.plugins = this.container.getAll(TYPES.ILayerPlugin); // 完成插件注册，传入场景和图层容器内的服务

      var _iterator = _createForOfIteratorHelper(this.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin.apply(this, {
            rendererService: this.rendererService,
            mapService: this.mapService,
            styleAttributeService: this.styleAttributeService,
            normalPassFactory: this.normalPassFactory,
            postProcessingPassFactory: this.postProcessingPassFactory
          });
        } // 触发 init 生命周期插件

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.hooks.init.call();
      this.hooks.afterInit.call();
      return this;
    }
  }, {
    key: "renderModels",
    value: function renderModels(isPicking) {
      var _this3 = this;

      this.models.forEach(function (model) {
        model.draw({
          uniforms: _this3.layerModel.getUninforms()
        }, isPicking);
      });
      return this;
    }
  }, {
    key: "getPickID",
    value: function getPickID() {
      return this.pickedID;
    }
  }, {
    key: "setPickID",
    value: function setPickID() {
      return this.pickedID;
    }
  }, {
    key: "buildModels",
    value: function buildModels() {
      var _this4 = this;

      var model = this.getModelType();
      this.layerModel = new model(this);
      this.layerModel.initModels(function (models) {
        _this4.dispatchModelLoad(models);
      });
    }
  }, {
    key: "rebuildModels",
    value: function rebuildModels() {
      var _this5 = this;

      this.layerModel.buildModels(function (models) {
        _this5.dispatchModelLoad(models);
      });
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      switch (this.layerType) {
        case 'PolygonLayer':
          return polygonFillModel;

        case 'LineLayer':
          return this.getLineModel();

        case 'PointLayer':
          return this.getPointModel();

        case 'MaskLayer':
          return maskModel;

        default:
          return pointFillModel;
      }
    }
  }, {
    key: "getLineModel",
    value: function getLineModel() {
      var _shapeAttribute$scale;

      var shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
      var shape = shapeAttribute === null || shapeAttribute === void 0 ? void 0 : (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;

      switch (shape) {
        case 'tileline':
        case 'line':
          return lineFillModel;

        case 'simple':
          return lineSimpleModel;

        default:
          return lineFillModel;
      }
    }
  }, {
    key: "getPointModel",
    value: function getPointModel() {
      var layerData = this.getEncodedData();

      var _this$getLayerConfig = this.getLayerConfig(),
          shape2d = _this$getLayerConfig.shape2d;

      var item = layerData.find(function (fe) {
        return fe.hasOwnProperty('shape');
      }); // only support pointFill & pointText now

      if (item) {
        var shape = item.shape;

        if ((shape2d === null || shape2d === void 0 ? void 0 : shape2d.indexOf(shape)) !== -1) {
          return pointFillModel;
        } else {
          return pointTextModel;
        }
      } else {
        return pointFillModel;
      }
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return {};
    }
  }]);

  return VectorLayer;
}(BaseLayer);

export { VectorLayer as default };